module.exports = __webpack_public_path__ + "img/hero-5.207627d7.jpg";